export const mindmap =
    {
        noMailMenu: true,
        rolesCanShowBannerInfo: ['administrator']
    };